import React from 'react';
import services from '../../services';
import CountUp from 'react-countup'
import { withRouter } from 'react-router-dom';
import TableHeader from './../common/table_header';
import TablePagination from './../common/TablePagination.js';
import Lang from '../../lang'
import Main from '../../Pages/Demo/main';
import SearchFilter from '../filters/SearchFilter';
import TitleBar from '../common/title_bar'
import FilterInputs from '../filters/FilterInputs';
import TkTablewithAction from '../tlelrik/TkTablewithAction';
import $ from 'jquery';
// import TlkTable from '../tlelrik/table/tlkTable';
import TlkTableparcel from '../tlelrik/table/TlkTableparcel';
import WizardDetailModalForm from '../common/wizard_detail_popup';
import EntityDetails from '../common/EntityDetails';
import ParcelVirsion from '../Parcel-Right-panel/ParcelVirsion';
import GoogleMapPopUp from '../common/GoogleMapPopUp';

const columnkeyMap = {
    numBoletim: "Nº Boletim",
    estado: "Estado Boletim",
    numProcesso: "Nº Processo",
    geocodigo: "Geocódigo",
    designacao: "Designação",
    freguesia: "Freguesia",
    estadoVinha: "Estado da Vinha",
    anoPlantacao: "Ano de Plantação",
    tipoDeCultura: "Tipo de Cultura",
}
// const TabName = [
//     {
//         name: "Total de área apta",
//         key: "areaapta"
//     },
//     {
//         name: "Total de área não apta",
//         key: "areanapta"
//     },
//     {
//         name: "Total A a F com MG",
//         key: "areaaf"
//     },
//     {
//         name: "Total área s/ enquadramento legal",
//         key: "areailegal"
//     }
// ]

const filters = {
    Tabs: {
        "Nº de Processo": [
            {
                key: 'numProcesso',
                displayKey: "Nº Processo",
                inputType: "text"
            }
        ],
        "Geocódigo": [
            {
                key: 'geocodigo',
                displayKey: "Geocódigo",
                inputType: "text"
            }
        ],
        "Ano de Boletim":[
            {
                key : 'anoPlantacao',
                displayKey : "Ano de Boletim",
                inputType : "text"
            }
        ],
        "Fiscal": [
            {
                key: 'registo',
                displayKey: "Fiscal responsavel pelo registo do boletim",
                inputType: "text"
            }
           
        ],
            Datas:[
                {
                    key: 'RangePicker',
                    displayKey: "intervalo de datas",
                    inputType: "RangePicker"
                }
            ]
    },
    checkbox : []
};

const groupfield = [
    //{ field: "Nº Parcela IVDP" },
    // { field: 'Distrito' },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
]

const aggregates = [
    // { field: "Área Apta", aggregate: 'sum' },
    // { field: "Área s/ enq legal", aggregate: 'sum' },
    // { field: "Área não Apta", aggregate: 'sum' },
    // { field: "A a F com MG", aggregate: 'sum' },

]

/* Array de configurações estáticas da página*/
// const optionMenuArray = [
//     { "main": "Tabelas de Gestão" },
//     { "main": "Enquadramento Legal" }
// ]
// const getkeyTableName = (res, key, customkey) => {

//     if (customkey !=="") {
//         if (customkey === "Explorer") {
//             return "explorer";
//         } else if (customkey === "Owner") {
//             return "property";
//         } else if (customkey === "Explorer/Owner") {
//             return "explorer_property";
//         }
//     }
//     else {
//         if (key in res.parcel) {
//             return "parcelfilter";
//         } else if (key in res.parcelProperty && key in res.parcelExplorer) {
//             return "explorer_property";
//         } else if (key in res.parcelProperty) {
//             return "property";
//         } else if (key in res.parcelExplorer) {
//             return "explorer";
//         }
//     }
//     return false;
// }


class BoletimFilter extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            showSearchMsg: false,
            totalcount: 0,
            entity_list_object: {},
            clickLimparFilter:false,
            customfilters: {},
            tlkfilter: {},
            date: new Date(),
            tabsComponentsView: null,
            popUpForm: ''
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        $(window).scrollTop(0);
        // this.createTabel();
    }

    componentDidUpdate(proProp) {
        if (proProp.date !== this.props.date) {
            this.setState({
                date: new Date(),
                clickLimparFilter : this.props.clickLimparFilter
            })
        }
    }

    /* Para baixar o arquivo lang json */
    getLangFile = () => {
        Lang.getJSON.getJSONFile();
    }

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {

    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let columnlist = Object.keys(columnkeyMap).map(function (key) {
            return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
        });
        let notFilterColumn = {
            "Área Apta": true,
            "Área s/ enq legal": true,
            "Área não Apta": true,
            "A a F com MG": true
        };
        let actionbuttons = { Edit: true, Redirect: false, Delete: false, Dropdown: false }
        let telkikTable = <TlkTableparcel
            date={new Date()}
            sendDatatoTlkTable={(filter) => this.sendDatatoTlkTable(filter)}
            columnwidth={60}
            aggregates={aggregates}
            notFilterColumn={notFilterColumn}
            list={this.state.data}
            modulename={"dashboard"}
            tlkState={this.state.tlkfilter}
            groupfield={groupfield}
            deleteFunc={(id) => this.handleDelete(id)}
            actionbuttons={actionbuttons}
            columnlist={columnlist}
            ActionPerform={(action, id) => this.ActionPerform(action, id)}
            actionColWidth={ 70 }
        />
        this.setState({
            telkikTable
        })
    }

    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    /* Obter a chave do filtro do filtro personalizado */

    getFilters(filters) {
        // console.log("filters",filters);
        this.setState({
            customfilters: filters,
            totalcount: 0,
            showSearchMsg: true,
            telkikTable: null,
            clickLimparFilter:false,
            tabsComponentsView: null
        }, () => {
            if (filters && (Object.keys(filters.filters).length === 0 && Object.keys(filters.filterCheckbox).length === 0)) {
                this.setState({showSearchMsg : false})
                return
            }
            else if (filters && (Object.keys(filters.filters).length > 0 || Object.keys(filters.filterCheckbox).length > 0)) {
                this.sendDatatoTlkTable({})
                // this.createTabel()
            }
        })


    }

    /* Tornar todos os tipos de filtros personalizados e tabelas em formatos de API */

    makeAllfilters = (tlfilter) => {
        let customfilters = { ...this.state.customfilters }
        let tlkfilter = tlfilter;
        if (Object.keys(tlkfilter).length === 0) {
            tlkfilter = { ...this.state.tlkfilter }
        }
        
        let data = {
            Filters: {},
            FiltersIn: null,
            FiltersLike: null,
            SortBy: "NumBoletim",
            IsSortTypeDESC: false,
            IsPagination: true,
            Page:  Math.ceil(tlkfilter.skip/tlkfilter.take) + 1 || 1,
            PageSize: tlkfilter.take || 100
        };
        
        Object.keys(customfilters.filters).map(key => {
            data['Filters'][key[0].toUpperCase()+key.slice(1)] = isNaN(+customfilters.filters[key]) ? customfilters.filters[key] : +customfilters.filters[key]
        })

        // data['Filters'] = {...customfilters.filters}
        // delete data.Filters.explorerlike;
        // delete data.Filters.ownerlike;
        // delete data.Filters["explorer/ownerlike"];
        // data.Filters.numparc = 1;
        return data;
    }


    /*  Atualizar os dados da tabela em chamadas de API dinâmicas */

    sendDatatoTlkTable = async (tlkfilter) => {
        // debugger
        this.setState({
            tlkfilter: tlkfilter,
            tabsComponentsView: null
        });
        let data = this.makeAllfilters(tlkfilter);
        let portugasdata = [];
        let url = "/boletim/searchboletim"
        let _Parcel = await services.apiCall.requestApi(url, data, 'post')

        if (_Parcel && _Parcel.length > 0) {
            _Parcel.map((_row, index) => {
                Object.keys(columnkeyMap).map(function (key) {
                    _row[columnkeyMap[key]] = _row[key]
                })
                portugasdata.push(_row)
            })
            
            this.setState({
                data: portugasdata,
                showSearchMsg: false,
                totalcount: window.localStorage.getItem('table_total')
            }, () => {
                this.createTabel()
            })
            // return portugasdata;
        }else{
            this.setState({showSearchMsg:true,data:[], telkikTable: null, totalcount:0})
        }
    }


    /* Deletar linha da tabela de dados */

    handleDelete = (id) => {

    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = async (action, row) => {
        console.log("......",row)
        if (action === 'Edit') {
            // window.location = "/wizard_form?id=" + row.numparc + "&versao=" + row.versao + "&geocode=" + row.geocod + "&status=" + row.status
            this.props.history.push({
                pathname: "/boletim_form",
                search: "?id=" + row.numBoletim + "&versao="+row.versao
            })
        }
    }


    /*Para obter detalhes de uma única entidade usando api */

    // getEntityDetails = async (entity_id) => {
    //     let Request = {};
    //     this.setState({
    //         entity_details: null
    //     });
    //     Request.entityId = parseInt(entity_id);
    //     let link = "/Revenue/getEntityDetail"
    //     let res = await services.apiCall.requestApi(link, Request);
    //     if (res) {
    //         this.setState({
    //             entity_details: res
    //         }, () => this.tabSectionView(this.state.data));
    //     }
    // }


    // tabSectionView = (data) => {
    //     let tabsComponentsView = ''
    //     if (data === '') {
    //         tabsComponentsView = ''
    //     } else {
    //         let tabSectionView = {
    //             areaapta: 0,
    //             areanapta: 0,
    //             areailegal: 0,
    //             areaaf: 0
    //         }
    //         data.map(_r => {
    //             tabSectionView['areaapta'] += _r.areaapta
    //             tabSectionView['areanapta'] += _r.areanapta
    //             tabSectionView['areailegal'] += _r.areailegal
    //             tabSectionView['areaaf'] += _r.areaaf
    //         })
    //         //console.log("tabSection", tabSectionView)
    //         tabsComponentsView = (
    //             <div className="tab-section">
    //                 <div className="d-md-flex justify-content-between">
    //                     {
    //                         TabName.map((_n, i) => (
    //                             <div key={i} className="innerBox">
    //                                 <p>{_n.name}</p>
    //                                 <h1>
    //                                     {tabSectionView[_n.key]}
    //                                 </h1>
    //                             </div>
    //                         ))
    //                     }
    //                     <EntityDetails
    //                         className="innerBox active d-flex align-items-center cursor-pointer"
    //                         entity={this.state.entity_details.busEntidade}
    //                         onlyDetails={true}
    //                         billobj={this.state.entity_details.billing_address}
    //                     />

    //                 </div>
    //             </div>
    //         )
    //     }
    //     this.setState({
    //         tabsComponentsView
    //     })
    // }

    // showEntityDetailPopUp = () => {
    //     let row = this.state.entity_list_object[this.state.popUpEntity]
    //     let detailPopUp = (
    //         <WizardDetailModalForm listData={row} tab={'detail'} />
    //     )
    //     this.setState({
    //         detailPopUp
    //     })
    // }


    refreshComponent = () => {
        this.setState({clickLimparFilter : true})
    }


    /*  Para renderizar o conteúdo html da página   */

    render() {
        // const rend = Math.random();
        // rend=879;
        return (

            <div className="inner-container">
                <div className="outer-space">
                     <TitleBar
                        onlyInicioLink={"/boletim"}
                        refreshComponent={()=>this.refreshComponent()}
                        path={this.props.linkData.TitleBarpath}
                        title={this.props.linkData.TitleBartitle}
                        logo={this.props.linkData.TitleBarlogo}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        changeOption={(mainIndex, subIndex) => this.props.changeOption(mainIndex, subIndex)} 
                        optionMenuArray={this.props.optionMenuArray} 
                        />
                </div>
                <div className="container-fluid">

                    <SearchFilter
                        showBoletim={true}
                        // moduleType="Boletim"
                        date={this.state.date}
                        clickLimparFilter={this.state.clickLimparFilter}
                        filters={filters}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        getFilter={(data) => this.getFilters(data)}
                    />

                    {
                        // this.state.tabsComponentsView
                    }

                

                    <div className="table-section">
                        {
                            <>
                                {
                                    <div className={(this.state.data && this.state.data.length) ? "" : "tlkwodata"}>
                                        {
                                            this.state.totalcount > 0 && <h3> A pesquisa retornou {this.state.totalcount} resultados </h3>
                                        }
                                        <div className="table-responsive">
                                            {
                                                this.state.telkikTable
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.totalcount == 0) &&
                                    <div className="searct-found">
                                        <img className="img-fluid" src="imgs/search-large-icon.png" />
                                        {
                                            this.state.showSearchMsg ? <p className="font-14">Sem resultados</p> : <h3>Pesquise por dados do Boletim para apresentação de mais informações</h3>
                                        }
                                    </div>
                                }
                            </>
                        }
                    </div>
                    {
                        <div className="modal left-popup" id="parcelPopups">
                            <div className="modal-dialog modal-lg">
                                {
                                    this.state.popUpForm
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(BoletimFilter);